/* ==========================================================================================
   BRS · Our Stores page (/pages/retail-store), 7 Oct 2026. Used only by sections/brs-stores.liquid.
   ------------------------------------------------------------------------------------------
   1. Picture cards for each store, in one of three styles (chosen in Customize, data-style on the section;
      ?brs_style=ring|deck|flow in the address overrides it for that visit, for comparing):
        ring  A · the cards stand on a slowly turning 3D ring; the front one is large, the sides lean away.
        deck  B · a stack of prints; the top one is flicked away and slides under the stack.
        flow  C · a tilted strip: the middle card faces you, its neighbours turn away (coverflow).
      Phone: swipe. Computer: arrows, and the mouse can drag the ring and the deck. Keyboard: left / right.
      The cards turn on their own every few seconds (Customize) and stop while the mouse rests on them,
      while a control has the keyboard focus, after any tap or swipe (until the play button is pressed), while
      the cards are off screen and while the tab is hidden. "Reduce motion" on the visitor's device: no turning,
      no film autoplay, no sliding.
      The film card plays (muted, inline) only while it is the front card and on screen; while it plays, the
      cards wait for the film to finish before moving on. Its file is only fetched when the store is near.
   2. Hours: "Open now · closes 9:30 pm" / "Closed now · opens 11:00 am" in India time above the written hours.
   3. Google rating: when a browser key is set in Customize and a store has a Place ID, the Maps JavaScript API
      is loaded once (only when a store's details come within a screen of view) and the store's rating, number
      of reviews and Google Maps link are fetched live from Google for that page view (nothing is stored).
      Shown as "4.8 ★★★★★ 1,234 Google reviews · Google Maps". Below the minimum set in Customize, without a
      key, or if anything fails, the "Read our Google reviews" link stays.
   Safety: never throws; does nothing on a page without the section. No other file on the site is touched.
   ========================================================================================== */
(function () {
  'use strict';
  var d = document, w = window;
  var STYLES = ['ring', 'deck', 'flow'];
  var SWIPE = 40;            /* px a finger or the mouse must travel sideways to count as a swipe */
  var NEAR = 1.5;            /* screens: fetch films and ratings when a store is this close */
  var FILM_MS = 8000;        /* used when the film's own length is not known yet */

  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function now() { return Date.now(); }
  function mod(a, n) { return ((a % n) + n) % n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mq(s) { try { return w.matchMedia && w.matchMedia(s).matches; } catch (e) { return false; } }
  function reduced() { return mq('(prefers-reduced-motion: reduce)'); }
  function saveData() { return !!(navigator.connection && navigator.connection.saveData); }
  function isPhone() { return w.innerWidth < 768; }
  function inView(el, extra) {
    if (!el) return false;
    var r = el.getBoundingClientRect(), h = w.innerHeight || d.documentElement.clientHeight;
    var m = (extra || 0) * h;
    return r.bottom > -m && r.top < h + m && r.width > 0;
  }
  function shown(el) {         /* share of the element's height that is on screen, 0..1 */
    if (!el) return 0;
    var r = el.getBoundingClientRect(), h = w.innerHeight || d.documentElement.clientHeight;
    if (!r.height || !r.width) return 0;
    return Math.max(0, Math.min(r.bottom, h) - Math.max(r.top, 0)) / r.height;
  }
  var SEEN = 0.35;           /* the cards turn and the film plays only when at least this share of them is on screen */
  function param(name) {
    try { var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(location.search); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }

  /* ---------------------------------------------------------------------------------------- */
  /* 1. cards                                                                                  */
  /* ---------------------------------------------------------------------------------------- */
  var ALL = [];

  function Cards(root, style, seconds) {
    var self = this;
    this.root = root; this.style = style;
    this.stage = q('.brs-cards__stage', root);
    this.track = q('.brs-cards__track', root);
    this.cards = qa('.brs-card', this.track);
    this.n = this.cards.length;
    this.i = 0;                                  /* front card; unbounded for the ring, so it always turns the short way */
    this.interval = Math.max(2, seconds || 0) * 1000;
    this.auto = seconds > 0 && !reduced() && this.n > 1;
    this.stopped = false;                        /* the visitor tapped, swiped or pressed pause */
    this.hover = false; this.focus = false; this.drag = null;
    this.nextAt = 0; this.wasRunning = false; this.loaded = false;
    this.capCount = q('.brs-cards__count', root);
    this.capText = q('.brs-cards__text', root);
    this.cap = q('.brs-cards__cap', root);
    this.ctrl = q('.brs-cards__ctrl', root);
    this.btnPrev = q('.brs-ctl--prev', root);
    this.btnNext = q('.brs-ctl--next', root);
    this.btnPause = q('.brs-ctl--pause', root);
    if (!this.n) return;

    root.classList.add('is-ready');
    this.cards.forEach(function (c, k) {
      c.setAttribute('role', 'group');
      c.setAttribute('aria-roledescription', 'slide');
      c.setAttribute('aria-label', (k + 1) + ' of ' + self.n);
    });
    if (this.ctrl && this.n > 1) this.ctrl.hidden = false;
    if (this.btnPause && !this.auto) { this.btnPause.hidden = !(seconds > 0) || this.n < 2; }

    if (style === 'flow') this.setupFlow(); else this.setupPointer();
    this.measure();
    this.render(0, true);
    this.bindControls();
    this.syncPause();
    this.nextAt = now() + this.interval;
    w.addEventListener('resize', function () { self.measure(); self.render(0, true); });
  }

  Cards.prototype.active = function () { return mod(Math.round(this.i), this.n); };
  Cards.prototype.running = function () {
    return this.auto && !this.stopped && !this.hover && !this.focus && !this.drag && !d.hidden && shown(this.stage) >= SEEN;
  };
  Cards.prototype.dwell = function (k) {
    var c = this.cards[k == null ? this.active() : k], v = c && c.getAttribute('data-kind') === 'film' ? q('video', c) : null;
    if (v && this.filmAllowed()) {
      var ms = (v.duration && isFinite(v.duration)) ? v.duration * 1000 : FILM_MS;
      return Math.max(this.interval, ms - 150);          /* move on just before the film would start again */
    }
    return this.interval;
  };
  Cards.prototype.filmAllowed = function () { return !reduced() && !saveData(); };

  Cards.prototype.measure = function () {
    var c = this.cards[0]; if (!c) return;
    this.cw = c.offsetWidth || 240; this.ch = c.offsetHeight || 300;
    if (this.style === 'ring') {
      var n = Math.max(this.n, 3);
      this.r = Math.round(this.cw / 2 / Math.tan(Math.PI / n) * 1.32);   /* air between the cards, as in the reference */
      this.root.style.setProperty('--brs-r', this.r + 'px');
    }
  };

  /* lays every card out for the current front card; drag = fraction of a step the finger has moved */
  Cards.prototype.render = function (drag, instant) {
    var self = this, n = this.n, a = this.active(), k;
    if (instant) this.root.classList.add('is-instant');
    if (this.style === 'ring') {
      var step = 360 / n, pos = this.i - (drag || 0);
      for (k = 0; k < n; k++) {
        var ang = (k - pos) * step, nrm = mod(ang + 180, 360) - 180, face = Math.cos(nrm * Math.PI / 180);
        var c = this.cards[k];
        c.style.transform = 'rotateY(' + ang.toFixed(3) + 'deg) translateZ(' + this.r + 'px)';
        c.style.setProperty('--dim', (face > 0.98 ? 0 : face < 0 ? 0.8 : Math.min(0.7, 0.22 + (1 - face) * 0.5)).toFixed(3));   /* the far side of the ring stays dark */
        c.style.zIndex = String(Math.round(100 + face * 100));
      }
    } else if (this.style === 'deck') {
      for (k = 0; k < n; k++) this.deckPlace(this.cards[k], mod(k - Math.round(this.i), n), k === a ? (drag || 0) : 0);
    } else if (this.style === 'flow') {
      this.flowPaint();
    }
    this.cards.forEach(function (c, k) {
      var on = k === a;
      c.classList.toggle('is-front', on);
      c.setAttribute('aria-hidden', on ? 'false' : 'true');
      qa('button', c).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    });
    this.caption();
    this.films();
    if (instant) { void this.track.offsetWidth; this.root.classList.remove('is-instant'); }
  };

  /* B · deck: p = place in the stack (0 = top); dx = how far the finger has pulled the top card (in card widths) */
  var PILE = [[0, 0, 0, 1], [26, 10, 5.5, 0.95], [-24, 16, -5, 0.91], [12, 26, 10, 0.87]];
  var FAN = [[0, 0, 0, 1], [86, 6, 9, 0.94], [-82, 12, -8.5, 0.9], [150, 22, 16, 0.85]];
  Cards.prototype.deckPlace = function (c, p, dx) {
    var set = (this.hover && !isPhone()) ? FAN : PILE, s = this.cw / 300;
    var v = set[Math.min(p, set.length - 1)];
    var x = v[0] * s, y = v[1] * s, rot = v[2], sc = v[3], op = p < set.length ? 1 : 0;
    if (p === 0 && dx) { x += dx * this.cw; rot += dx * 14; }
    c.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc + ')';
    c.style.opacity = String(op);
    c.style.zIndex = String(100 - p);
    c.style.setProperty('--dim', p === 0 ? '0' : (0.1 + p * 0.07).toFixed(2));
  };

  /* C · flow: each card turns according to its distance from the middle of the strip */
  Cards.prototype.flowPaint = function () {
    var t = this.track, mid = t.scrollLeft + t.clientWidth / 2, best = 0, bestD = 1e9, self = this;
    this.cards.forEach(function (c, k) {
      var center = c.offsetLeft + c.offsetWidth / 2, off = (center - mid) / (self.cw * 0.82);
      var o = Math.max(-2.2, Math.min(2.2, off)), ab = Math.abs(o);
      var rot = Math.max(-52, Math.min(52, -o * 46));
      var sc = 1 - Math.min(ab, 1.6) * 0.13;
      c.style.transform = 'perspective(900px) translateZ(' + (-Math.min(ab, 1.6) * 70).toFixed(1) + 'px) rotateY(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
      c.style.zIndex = String(100 - Math.round(ab * 10));
      c.style.setProperty('--dim', Math.min(0.62, ab * 0.42).toFixed(3));
      if (Math.abs(center - mid) < bestD) { bestD = Math.abs(center - mid); best = k; }
    });
    return best;
  };
  Cards.prototype.setupFlow = function () {
    var self = this, t = this.track, ticking = false, settle = 0;
    t.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; (w.requestAnimationFrame || setTimeout)(function () { ticking = false; self.flowPaint(); }); }
      clearTimeout(settle);
      settle = setTimeout(function () {
        var b = self.flowPaint();
        if (b !== self.active()) { self.i = b; self.render(0); }
      }, 90);
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      t.addEventListener(ev, function (e) { if (ev !== 'wheel' || Math.abs(e.deltaX || 0) > Math.abs(e.deltaY || 0)) self.userStop(); }, { passive: true });
    });
    this.cards.forEach(function (c, k) {
      c.addEventListener('click', function (e) {
        if (k !== self.active()) { e.preventDefault(); self.userStop(); self.go(k - self.active()); }
      });
    });
  };
  Cards.prototype.flowScroll = function (k, instant) {
    var c = this.cards[k], t = this.track; if (!c) return;
    var left = c.offsetLeft + c.offsetWidth / 2 - t.clientWidth / 2;
    try { t.scrollTo({ left: left, behavior: (instant || reduced()) ? 'auto' : 'smooth' }); } catch (e) { t.scrollLeft = left; }
  };

  /* A and B: finger / mouse drag on the stage */
  Cards.prototype.setupPointer = function () {
    var self = this, st = this.stage, start = null, moved = false;
    function x(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
    function y(e) { return e.touches ? e.touches[0].clientY : e.clientY; }
    function down(e) {
      if (e.button != null && e.button !== 0) return;
      start = { x: x(e), y: y(e), t: now(), axis: '' }; moved = false;
    }
    function move(e) {
      if (!start) return;
      var dx = x(e) - start.x, dy = y(e) - start.y;
      if (!start.axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        start.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (start.axis === 'x') { self.drag = { dx: 0 }; self.root.classList.add('is-dragging'); self.userStop(); }
      }
      if (start.axis !== 'x') return;
      if (e.cancelable) e.preventDefault();
      moved = true;
      var frac = dx / (self.style === 'ring' ? self.cw * 1.05 : self.cw);
      self.drag.dx = frac;
      self.render(frac);
    }
    function up() {
      if (!start) return;
      var frac = self.drag ? self.drag.dx : 0, px = frac * self.cw;
      start = null; self.drag = null;
      self.root.classList.remove('is-dragging');
      if (Math.abs(px) >= SWIPE) {
        if (self.style === 'ring') { var steps = Math.max(1, Math.round(Math.abs(frac) * 1.05)); self.go(frac < 0 ? steps : -steps); }
        else self.go(1, frac < 0 ? 'left' : 'right');            /* the deck: a flick either way sends the top print away */
      } else self.render(0);
    }
    if (w.PointerEvent) {
      st.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') down(e); });
      w.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') move(e); });
      w.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') up(e); });
    }
    st.addEventListener('touchstart', down, { passive: true });
    st.addEventListener('touchmove', move, { passive: false });
    st.addEventListener('touchend', up); st.addEventListener('touchcancel', up);
    st.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; return; }
      var card = e.target.closest ? e.target.closest('.brs-card') : null; if (!card) return;
      var k = self.cards.indexOf(card), a = self.active();
      if (k < 0 || k === a || e.target.closest('.brs-card__play')) return;
      self.userStop();
      if (self.style === 'ring') { var diff = mod(k - a, self.n); self.go(diff > self.n / 2 ? diff - self.n : diff); }
      else self.go(1);
    }, true);
    st.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  /* move by delta cards (dir: which way the deck card leaves) */
  Cards.prototype.go = function (delta, dir) {
    if (!delta || this.n < 2) return;
    var self = this;
    this.nextAt = now() + this.dwell(mod(this.active() + delta, this.n));   /* a film in front holds the cards for its length */
    if (this.style === 'flow') {
      this.i = mod(this.active() + delta, this.n);
      this.flowScroll(this.i);
      this.render(0);
    } else if (this.style === 'deck') {
      if (this.busy) return;
      var a = this.active(), c;
      if (delta > 0) {
        this.busy = true;
        c = this.cards[a];
        var out = dir === 'right' ? 1 : -1;
        c.classList.add('is-out');
        c.style.zIndex = '200';
        c.style.transform = 'translate(' + (out * this.cw * 1.15).toFixed(0) + 'px,' + (-this.ch * 0.04).toFixed(0) + 'px) rotate(' + (out * 14) + 'deg)';
        setTimeout(function () { c.classList.remove('is-out'); self.i += 1; self.busy = false; self.render(0); }, reduced() ? 0 : 300);
      } else {
        c = this.cards[mod(a - 1, this.n)];
        this.root.classList.add('is-instant');
        c.style.zIndex = '200'; c.style.opacity = '1';
        c.style.transform = 'translate(' + (-this.cw * 1.15).toFixed(0) + 'px,0) rotate(-14deg)';
        void c.offsetWidth;
        this.root.classList.remove('is-instant');
        this.i -= 1; this.render(0);
      }
    } else {
      this.i += delta;
      this.render(0);
    }
  };

  Cards.prototype.caption = function () {
    var a = this.active(), c = this.cards[a];
    if (this.capCount) this.capCount.textContent = (a < 9 ? '0' : '') + (a + 1) + ' / ' + (this.n < 10 ? '0' : '') + this.n;
    if (this.capText && c) this.capText.textContent = c.getAttribute('data-caption') || '';
  };

  /* films: play only the front one, only on screen, only when allowed */
  Cards.prototype.films = function () {
    var self = this, a = this.active(), near = inView(this.root, NEAR), seen = shown(this.stage) >= SEEN;
    this.cards.forEach(function (c, k) {
      if (c.getAttribute('data-kind') !== 'film') return;
      var v = q('video', c); if (!v) return;
      if (near && !v.getAttribute('src') && v.getAttribute('data-src')) { v.setAttribute('src', v.getAttribute('data-src')); v.preload = 'metadata'; }
      /* the front film plays by itself (muted) unless the visitor paused it, or asks for less motion / less data */
      var want = k === a && seen && !d.hidden && !c._userPause && (c._userPlay || self.filmAllowed());
      if (want) {
        if (v.paused) { try { var p = v.play(); if (p && p.catch) p.catch(function () { c.classList.remove('is-playing'); }); } catch (e) {} }
      } else if (!v.paused) { try { v.pause(); } catch (e) {} }
    });
  };

  Cards.prototype.userStop = function () {
    if (this.stopped) return;
    this.stopped = true; this.syncPause();
  };
  Cards.prototype.syncPause = function () {
    var b = this.btnPause; if (!b) return;
    var paused = this.stopped || !this.auto;
    b.classList.toggle('is-paused', paused);
    b.setAttribute('aria-label', paused ? 'Play the pictures' : 'Pause the pictures');
    if (this.cap) this.cap.setAttribute('aria-live', paused ? 'polite' : 'off');
  };

  Cards.prototype.bindControls = function () {
    var self = this;
    if (this.btnPrev) this.btnPrev.addEventListener('click', function () { self.userStop(); self.go(-1); });
    if (this.btnNext) this.btnNext.addEventListener('click', function () { self.userStop(); self.go(1); });
    if (this.btnPause) this.btnPause.addEventListener('click', function () {
      if (self.stopped || !self.auto) { self.stopped = false; self.auto = self.n > 1; self.nextAt = now() + self.interval; }
      else self.stopped = true;
      self.syncPause(); self.films();
    });
    this.root.addEventListener('mouseenter', function () { self.hover = true; if (self.style === 'deck') self.render(0); });
    this.root.addEventListener('mouseleave', function () { self.hover = false; self.nextAt = now() + self.interval; if (self.style === 'deck') self.render(0); });
    this.root.addEventListener('focusin', function () { self.focus = true; });
    this.root.addEventListener('focusout', function () { self.focus = false; });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); self.userStop(); self.go(e.key === 'ArrowRight' ? 1 : -1); }
    });
    this.cards.forEach(function (c) {
      var btn = q('.brs-card__play', c), v = q('video', c);
      if (!btn || !v) return;
      v.addEventListener('playing', function () { c.classList.add('is-playing'); });
      v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
      v.addEventListener('loadedmetadata', function () { if (self.cards[self.active()] === c) self.nextAt = now() + self.dwell(); });
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (self.cards[self.active()] !== c) return;
        if (v.paused) { c._userPause = false; c._userPlay = true; if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src') || ''); }
        else { c._userPause = true; c._userPlay = false; self.userStop(); }
        self.films();
      });
    });
  };

  /* one clock for every card set: moves them on, starts and stops films as they come and go */
  Cards.prototype.tick = function () {
    var run = this.running();
    if (run && !this.wasRunning) this.nextAt = now() + this.dwell();   /* back on screen / mouse gone: a full turn first */
    this.wasRunning = run;
    if (run && now() >= this.nextAt) this.go(1);
    this.films();
  };

  /* ---------------------------------------------------------------------------------------- */
  /* 2. open / closed now, India time                                                          */
  /* ---------------------------------------------------------------------------------------- */
  function fmt(hm) { var p = hm.split(':'), h = +p[0], m = p[1] || '00'; var ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + ':' + m + ' ' + ap; }
  function mins(hm) { var p = hm.split(':'); return (+p[0]) * 60 + (+(p[1] || 0)); }
  function istNow() {
    try {
      var s = new Date().toLocaleTimeString('en-GB', { timeZone: 'Asia/Kolkata', hour12: false, hour: '2-digit', minute: '2-digit' });
      var p = s.match(/(\d+):(\d+)/); return p ? (+p[1] % 24) * 60 + (+p[2]) : null;
    } catch (e) { return null; }
  }
  function hours(sec) {
    var t = istNow(); if (t === null) return;
    qa('.brs-hrs[data-open][data-close]', sec).forEach(function (dd) {
      var o = dd.getAttribute('data-open'), c = dd.getAttribute('data-close');
      if (!/^\d{1,2}:\d{2}$/.test(o) || !/^\d{1,2}:\d{2}$/.test(c)) return;
      var line = q('.brs-hrs__now', dd);
      if (!line) { line = d.createElement('span'); dd.insertBefore(line, dd.firstChild); }
      var open = t >= mins(o) && t < mins(c);
      line.className = 'brs-hrs__now' + (open ? '' : ' is-closed');
      line.innerHTML = '<span class="brs-dot" aria-hidden="true"></span>' + (open ? 'Open now · closes ' + esc(fmt(c)) : 'Closed now · opens ' + esc(fmt(o)));
    });
  }

  /* ---------------------------------------------------------------------------------------- */
  /* 3. live Google rating                                                                      */
  /* ---------------------------------------------------------------------------------------- */
  var mapsLoading = null;
  function loadMaps(key) {
    if (mapsLoading) return mapsLoading;
    mapsLoading = new Promise(function (resolve, reject) {
      if (w.google && w.google.maps && w.google.maps.importLibrary) { resolve(); return; }
      var cb = '__brsMapsReady', prev = w.gm_authFailure;
      w[cb] = function () { resolve(); };
      w.gm_authFailure = function () { reject(new Error('Google Maps key refused')); if (typeof prev === 'function') try { prev(); } catch (e) {} };
      var s = d.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async&libraries=places&callback=' + cb;
      s.async = true;
      s.onerror = function () { reject(new Error('Google Maps did not load')); };
      d.head.appendChild(s);
      setTimeout(function () { reject(new Error('Google Maps timed out')); }, 15000);
    });
    return mapsLoading;
  }
  function stars(r) { return '<span class="brs-stars" role="img" aria-label="Rated ' + r.toFixed(1) + ' out of 5"><span class="brs-stars__fill" style="width:' + Math.max(0, Math.min(100, r / 5 * 100)).toFixed(1) + '%"></span></span>'; }
  function showRating(dd, place, min) {
    var r = place && typeof place.rating === 'number' ? place.rating : null;
    var n = place && typeof place.userRatingCount === 'number' ? place.userRatingCount : 0;
    var url = (place && place.googleMapsURI) || '';
    var link = q('.brs-rate__link', dd);
    if (url && link) link.href = url;
    if (r === null || n < 1 || r < min) return;          /* keep "Read our Google reviews" */
    var href = esc(url || (link && link.href) || '#');
    var count = n.toLocaleString('en-IN') + ' Google review' + (n === 1 ? '' : 's');
    dd.classList.add('is-live');
    dd.innerHTML = '<span class="brs-rate__score">' + r.toFixed(1) + '</span>' + stars(r) +
      '<a class="brs-rate__link" href="' + href + '" target="_blank" rel="noopener">' + esc(count) + '</a>' +
      '<span class="brs-rate__by">Google Maps</span>';
  }
  function ratings(sec) {
    var key = (sec.getAttribute('data-key') || '').trim();
    var min = parseFloat(sec.getAttribute('data-min-rating')) || 0;
    var list = qa('.brs-rate[data-place]', sec).filter(function (dd) { return (dd.getAttribute('data-place') || '').trim(); });
    if (!key || !list.length) return function () {};
    var failed = false;
    return function check() {
      if (failed) return;
      list.forEach(function (dd) {
        if (dd._brsAsked || !inView(dd, 1)) return;
        dd._brsAsked = true;
        loadMaps(key).then(function () { return w.google.maps.importLibrary('places'); }).then(function (lib) {
          var place = new lib.Place({ id: dd.getAttribute('data-place').trim(), requestedLanguage: 'en' });
          return place.fetchFields({ fields: ['rating', 'userRatingCount', 'googleMapsURI'] }).then(function () { return place; });
        }).then(function (place) { showRating(dd, place, min); })['catch'](function (e) {
          failed = true; if (w.console && console.warn) console.warn('BRS rating', e && e.message ? e.message : e);
        });
      });
    };
  }

  /* ---------------------------------------------------------------------------------------- */
  function boot() {
    try {
      var secs = qa('[data-brs]');
      if (!secs.length) return;
      var checks = [];
      secs.forEach(function (sec) {
        var style = (param('brs_style') || sec.getAttribute('data-style') || 'ring').toLowerCase();
        if (STYLES.indexOf(style) < 0) style = 'ring';
        STYLES.forEach(function (s) { sec.classList.remove('brs--' + s); });
        sec.classList.add('brs--' + style); sec.setAttribute('data-style', style);
        var secs2 = parseInt(sec.getAttribute('data-autoplay'), 10) || 0;
        qa('[data-cards]', sec).forEach(function (el) { if (!el._brs) { el._brs = new Cards(el, style, secs2); ALL.push(el._brs); } });
        hours(sec);
        checks.push(ratings(sec));
        setInterval(function () { hours(sec); }, 60000);
      });
      var last = 0;
      function onScroll() {
        var t = now(); if (t - last < 120) return; last = t;
        checks.forEach(function (f) { f(); });
        ALL.forEach(function (c) { c.films(); });
      }
      w.addEventListener('scroll', onScroll, { passive: true });
      w.addEventListener('resize', onScroll);
      d.addEventListener('visibilitychange', function () { ALL.forEach(function (c) { c.films(); }); });
      setInterval(function () { ALL.forEach(function (c) { try { c.tick(); } catch (e) {} }); checks.forEach(function (f) { f(); }); }, 250);
      onScroll();
    } catch (e) { if (w.console && console.warn) console.warn('BRS', e); }
  }
  w.BRStoresPage = { boot: boot };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
